const partnerName = process.env.REACT_APP_PARTNER_NAME;

export const setEnvironment = (): string => {
  const domain = window.location.hostname.split('.')?.[0];
  return !domain || domain === 'localhost' ? '' : domain.includes('-test') ? 'test' : 'production';
};

export const setPartnerSite = (): string => {
  const hostname = window.location.hostname.split('.')?.[0]?.replace('-test', '');
  return ['localhost', 'portal'].includes(hostname) ? 'wechooose' : `${hostname}portal`;
};

export const setAccountType = (site: string): string => (site === 'wechooose' ? 'corporate' : 'portal');

export const tags = {
  portalOffset: {
    entry: {
      event: 'TrackingEvent',
      eventCategory: 'PortalOffset',
      eventAction: 'Entry',
      eventLabel: partnerName,
    },
    next: {
      event: 'TrackingEvent',
      eventCategory: 'PortalOffset',
      eventAction: 'Next',
      eventLabel: partnerName,
    },
    placeOrder: {
      event: 'TrackingEvent',
      eventCategory: 'PortalOffset',
      eventAction: 'PlaceOrder',
      eventLabel: partnerName,
    },
  },
  portalFootprint: {
    entry: {
      event: 'TrackingEvent',
      eventCategory: 'PortalFootprint',
      eventAction: 'Entry',
      eventLabel: partnerName,
    },
    next: {
      event: 'TrackingEvent',
      eventCategory: 'PortalFootprint',
      eventAction: 'Next',
      eventLabel: partnerName,
    },
    placeOrder: {
      event: 'TrackingEvent',
      eventCategory: 'PortalFootprint',
      eventAction: 'PlaceOrder',
      eventLabel: partnerName,
    },
  },
  portalQuickOffset: {
    next: {
      event: 'TrackingEvent',
      eventCategory: 'PortalQuickOffset',
      eventAction: 'Next',
      eventLabel: partnerName,
    },
    placeOrder: {
      event: 'TrackingEvent',
      eventCategory: 'PortalQuickOffset',
      eventAction: 'PlaceOrder',
      eventLabel: partnerName,
    },
  },
  registration: {
    createAccount: {
      event: 'TrackingEvent',
      eventCategory: 'SignupWeChooose',
      eventAction: 'CreateAccount',
      eventLabel: partnerName,
    },
  },
};

interface TrackableTransactionProduct {
  price: number;
  category: string;
  quantity: number;
  name: string;
  sku: string;
}

interface Signup {
  event_name: string;
  account_type: string;
  partner_site: string;
  partnership_id: string;
  environment: string;
  customer_company?: string | null;
  company_size?: string;
}

interface TagData {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  categories?: Array<string>;
  transactionId?: string;
  transactionTotal?: number;
  currencyCode?: string;
  transactionProducts?: Array<TrackableTransactionProduct>;
  trackingEvent_signup_complete_account?: Signup;
  trackingEvent_signup_create_account?: Signup;
  trackingEvent_signup_start?: Signup;
}

export const setTag = (data: TagData = {}): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const domain = window.location.hostname.split('.')?.[0];

  if (!domain || domain === 'localhost') {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push(function () {
    // @ts-ignore
    this.reset();
  });
  const start = new Date().getTime();
  window.dataLayer.push({
    ...data,
    gtm: {
      start,
    },
  });
};
